import {
  MyLeaveAdminSettingsPage,
  MyLeaveApproveLeaveRequestsPage,
  MyLeaveExaminerDashboardPage,
  MyLeaveHandleLeaveRequestsPage,
  MyLeaveMyLeaveRequestPage,
  MyLeaveMyRequestsPage,
  MyLeaveMyYearlyLeavesPage,
  MyLeaveUserRequestPage,
  MyLeaveUserRequestsPage,
  MyLeaveViewLeaveRequestsPage,
} from "my-leave/pages";

export const myLeaveExaminerDashboardPageRoutePath = "/my-leave/dashboard";
export const myLeaveMyRequestsPageRoutePath = "/my-leave/my-requests";
export const myLeaveMyRequestByIdPageRoutePath = "/my-leave/my-request/:id";
export const myLeaveMyYearlyLeavesByYearPageRoutePath =
  "/my-leave/my-yearly-leaves/:year";
export const myLeaveApproveLeaveRequestsPageRoutePath =
  "/my-leave/approve-requests";
export const myLeaveViewLeaveRequestsPageRoutePath = "/my-leave/view-requests";
export const myLeaveHandleLeaveRequestsPageRoutePath =
  "/my-leave/handle-requests";
export const myLeaveUserLeaveRequestsPageRoutePath =
  "/my-leave/user-requests/:product/:role/:contract";
export const myLeaveUserLeaveRequestByIdPageRoutePath =
  "/my-leave/user-request/:product/:role/:contract/:id";
export const myLeaveAdminSettingsPageRoutePath = "/my-leave/admin/settings";

export const buildMyLeaveMyRequestByIdPageRoutePath = (id: string) =>
  `/my-leave/my-request/${id}`;
export const buildMyLeaveMyYearlyLeavesByYearPageRoutePath = (year: string) =>
  `/my-leave/my-yearly-leaves/${year}`;
export const buildMyLeaveUserLeaveRequestsPageRoutePath = (
  product: string,
  role: string,
  contract: string,
) => `/my-leave/user-requests/${product}/${role}/${contract}`;
export const buildMyLeaveUserLeaveRequestByIdPageRoutePath = (
  product: string,
  role: string,
  contract: string,
  id: string,
) => `/my-leave/user-request/${product}/${role}/${contract}/${id}`;

export const myLeaveRoutes = [
  {
    id: "myLeaveExaminerDashboardPageRoute",
    path: myLeaveExaminerDashboardPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveExaminerDashboardPage,
    roles: ["MyLeave.examiner", "MyLeave.viewer", "MyLeave.assigner"],
  },
  {
    id: "myLeaveMyRequestsPageRoute",
    path: myLeaveMyRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveMyRequestsPage,
    roles: ["MyLeave.user"],
  },
  {
    id: "myLeaveMyRequestByIdPageRoute",
    path: myLeaveMyRequestByIdPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveMyLeaveRequestPage,
    roles: ["MyLeave.user"],
  },
  {
    id: "myLeaveMyYearlyLeavesByYearPageRoute",
    path: myLeaveMyYearlyLeavesByYearPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveMyYearlyLeavesPage,
    roles: ["MyLeave.user"],
  },
  {
    id: "myLeaveApproveLeaveRequestsPageRoute",
    path: myLeaveApproveLeaveRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveApproveLeaveRequestsPage,
    roles: ["MyLeave.examiner"],
  },
  {
    id: "myLeaveViewLeaveRequestsPageRoute",
    path: myLeaveViewLeaveRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveViewLeaveRequestsPage,
    roles: ["MyLeave.viewer"],
  },
  {
    id: "myLeaveHandleLeaveRequestsPageRoute",
    path: myLeaveHandleLeaveRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveHandleLeaveRequestsPage,
    roles: ["MyLeave.admin"],
  },
  {
    id: "myLeaveUserLeaveRequestsPageRoute",
    path: myLeaveUserLeaveRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveUserRequestsPage,
    roles: ["MyLeave.examiner", "MyLeave.viewer", "MyLeave.assigner"],
  },
  {
    id: "myLeaveUserLeaveRequestByIdPageRoute",
    path: myLeaveUserLeaveRequestByIdPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveUserRequestPage,
    roles: ["MyLeave.examiner", "MyLeave.viewer", "MyLeave.assigner"],
  },
  {
    id: "myLeaveAdminSettingsPageRoute",
    path: myLeaveAdminSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyLeaveAdminSettingsPage,
    roles: ["MyHR.admin"],
  },
];
